import PropTypes from 'prop-types'
import { memo, useCallback } from 'react'
import FX from '@/components/core/FX/FX'
import Link from '@/components/core/Link/Link'
import BlockText from '@/components/elements/BlockText/BlockText'
import ClipWedge from '@/components/elements/ClipWedge/ClipWedge'
import SplitTextRows from '@/components/util/SplitTextRows/SplitTextRows'
import { useModalContext } from '../../provider/ModalProvider'
import * as styles from './Header.module.scss'

/**
 * The `Header`
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function Header (props) {
  const { children } = props
  const { onAction } = useModalContext()

  const handleClick = useCallback(() => {
    onAction('close')
  }, [])

  return (
    <div className={styles.container}>
      <FX.Switch isActive={true} className={styles.header}>
        <div className={styles.title}>
          <SplitTextRows
            renderRow={(children, i) => (
              <ClipWedge key={i}>
                <BlockText Tag="h2">{children}</BlockText>
              </ClipWedge>
            )}
          >
            <BlockText Tag="h2">{children}</BlockText>
          </SplitTextRows>
        </div>

        <FX.Wipe className={styles.option} delay={0.1} direction="left">
          <Link onClick={handleClick} className={styles.close}>
            Close
          </Link>
        </FX.Wipe>
      </FX.Switch>
    </div>
  )
}

/** @type {object} */
Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
}

/** @type {object} */
Header.defaultProps = {
  className: '',
  children: []
}

// Memoize
export default memo(Header)
